class ZptStorefrontMarquee {
  static SPEEDS = {
    1: 70,
    2: 90,
    3: 115,
    4: 145,
    5: 180
  };

  static DEFAULT_SPEED = 3;
  static RESIZE_DELAY = 120;
  static MINIMUM_WIDTH_FACTOR = 1.5;

  constructor(element) {
    this.element = element;

    this.viewport = element.querySelector(
      '.zpt-marquee__viewport'
    );

    this.source = element.querySelector(
      '[data-zpt-marquee-source]'
    );

    this.track = element.querySelector(
      '[data-zpt-marquee-track]'
    );

    this.resizeTimer = null;

    if (!this.viewport || !this.source || !this.track) {
      return;
    }

    this.items = [
      ...this.source.querySelectorAll(
        '.zpt-marquee__item'
      )
    ];

    if (!this.items.length) {
      return;
    }

    this.onResize = this.onResize.bind(this);

    this.build();

    window.addEventListener(
      'resize',
      this.onResize
    );

    document.fonts?.ready.then(() => {
      this.build();
    });
  }

  getSpeed() {
    const level =
      Number(this.element.dataset.speed) ||
      ZptStorefrontMarquee.DEFAULT_SPEED;

    return (
      ZptStorefrontMarquee.SPEEDS[level] ??
      ZptStorefrontMarquee.SPEEDS[
        ZptStorefrontMarquee.DEFAULT_SPEED
      ]
    );
  }

  createSet() {
    const set = document.createElement('div');

    set.className = 'zpt-marquee__set';

    this.items.forEach((item) => {
      set.appendChild(item.cloneNode(true));
    });

    return set;
  }

  fillSet(set) {
    const viewportWidth = this.viewport.clientWidth;

    if (!viewportWidth) {
      return;
    }

    const initialWidth =
      set.getBoundingClientRect().width;

    if (!initialWidth) {
      return;
    }

    const minimumWidth =
      viewportWidth *
      ZptStorefrontMarquee.MINIMUM_WIDTH_FACTOR;

    const repetitions = Math.max(
      1,
      Math.ceil(minimumWidth / initialWidth)
    );

    for (
      let repeat = 1;
      repeat < repetitions;
      repeat += 1
    ) {
      this.items.forEach((item) => {
        set.appendChild(item.cloneNode(true));
      });
    }
  }

  build() {
    this.track.replaceChildren();

    const firstSet = this.createSet();

    this.track.appendChild(firstSet);

    this.fillSet(firstSet);

    const setWidth =
      firstSet.getBoundingClientRect().width;

    if (!setWidth) {
      return;
    }

    const secondSet = firstSet.cloneNode(true);

    secondSet.setAttribute(
      'aria-hidden',
      'true'
    );

    this.track.appendChild(secondSet);

    this.element.style.setProperty(
      '--zpt-marquee-set-width',
      `${setWidth}px`
    );

    this.element.style.setProperty(
      '--zpt-marquee-duration',
      `${setWidth / this.getSpeed()}s`
    );
  }

  onResize() {
    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(
      () => this.build(),
      ZptStorefrontMarquee.RESIZE_DELAY
    );
  }
}

const initZptStorefrontMarquees = (root = document) => {
  const marquees = [];

  if (root.matches?.('[data-zpt-marquee]')) {
    marquees.push(root);
  }

  if (root.querySelectorAll) {
    marquees.push(
      ...root.querySelectorAll(
        '[data-zpt-marquee]'
      )
    );
  }

  marquees.forEach((marquee) => {
    if (
      marquee.dataset.zptMarqueeInitialized ===
      'true'
    ) {
      return;
    }

    marquee.dataset.zptMarqueeInitialized = 'true';

    new ZptStorefrontMarquee(marquee);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initZptStorefrontMarquees(),
    { once: true }
  );
} else {
  initZptStorefrontMarquees();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initZptStorefrontMarquees(event.target);
  }
);